import { render, staticRenderFns } from "./ProductPagesContainer.vue?vue&type=template&id=013ab825&"
import script from "./ProductPagesContainer.vue?vue&type=script&lang=js&"
export * from "./ProductPagesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports